export const checkNoResults = (fetchComplete, data, originalData, info, country) => {
    // If fetch hasn't completed yet, don't show "no results"
    if (!fetchComplete) {
        return false;
    }

    // Check if fetch completed but no data returned
    if (!data || !originalData || originalData.length === 0) {
        return true;
    }

    // Check if data structure exists
    if (!data.datasets || !data.labels) {
        return true;
    }

    // Check if datasets contain data
    if (!data.datasets.some(ds => ds.data && ds.data.length > 0)) {
        return true;
    }

    // Check if labels exist
    if (data.labels.length === 0) {
        return true;
    }

    // Special check for area-grouped charts (when comparing countries)
    // Only return "no data" if groupByKey is "area" AND the selected country is missing
    if (data.groupByKey === "area") {
        const hasCountryData = data.datasets.some(ds =>
            ds.label && ds.label.toLowerCase() === country.toLowerCase()
        );
        const hasCountryInRaw = Array.isArray(originalData) && originalData.some(row =>
            row.area && row.area.toLowerCase() === country.toLowerCase()
        );
        if (!hasCountryData && !hasCountryInRaw) {
            return true;
        }
    }

    // All checks passed, we have data
    return false;
};
